/**
 * Step of the help tutorial of a page
 */

class IAHelpStep {

  /**
   * IAHelpStep constructor
   * @param {Array|HTMLElement|String} elt - array of HTMLElement of jQuery-understandable strings
   * @param {String} text - Displayed text alongside the highlighted elt
   * @param {Function} onNext - Callback called when going to the next step
   * @param {Array} links - Array of objects with a 'title' and 'action' props.
   *                        Buttons at the end of the text, when clicking a button, action is called
   */
  constructor(elt, text, onNext, links) {
    this.elt = elt || null;
    this.text = text || "";
    this.onNext = typeof onNext == "function" ? onNext : null;
    this.links = links;
  }
}

export default IAHelpStep;
